<template>
  <div id="zt8410">
    <div id="z1">
      <div>ZT8410</div>
      <label>桌面彩票销售终端</label>
    </div>
    <div id="z2">
      <label>ZT8410是一款集成二维码识别、彩票打印、彩票兑奖等多功能彩票销售终端。其多种通讯方式方便用户接入网络；强大处理能力与丰富外设接口能满足客户各种应用需求。</label>
    </div>
    <div id="z3">
      <div>大有可为  细至毫厘</div>
      <label>10.1寸大屏幕显示，全视角全方位展示绚彩界面1920 x 1200超高清分辨率，色彩饱满真实</label>
      <div>专注打印  时刻无忧</div>
      <label>150mm/s高速静音打印机，告别嘈杂与卡顿。支持80mm或82.5mm彩票专用纸卷</label>
    </div>
    <div id="z4">
      <div>全面覆盖  畅通无阻</div>
      <label>多种连接通道，支持4G全网通、WiFi、蓝牙、有线以太网</label>
    </div>
    <pdspecs :data="spdata"></pdspecs>
  </div>
</template>

<script>
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      spdata: {
        file: 'ZT8410',
        data: [
          {label: _this.$t('lang.cpu'), desc: [_this.$t('lang.arm82gcpu'),_this.$t('lang.qc411gcpu')],pic: 'cpu.png'},
          {label: _this.$t('lang.memory'), desc: ['3GB RAM + 32GB ROM','1GB RAM + 8GB ROM'],pic: 'ram.png'},
          {label: _this.$t('lang.os'), desc: ['Android 9.0','Android 5.1'], pic: 'sys.png'},
          {label: _this.$t('lang.display'), desc: ['10.1英寸1200×1920','10.1英寸600×1024'], pic: 'disp.png'},
          {label: _this.$t('lang.camera'), desc: ['500万像素定焦摄像头', '支持扫码，支持PDF417码、QR彩票点阵码'], pic: 'face.png'},
          {label: _this.$t('lang.printer'), desc: ['内置80 / 82.5mm高速热敏打印机','打印速度150mm /s','支持外径120mm纸卷'], pic: 'prt.png'},
          {label: _this.$t('lang.mobinet'), desc: [_this.$t('lang.sptnettype')], pic: 'mobi.png'},
          {label: 'WIFI', desc: [_this.$t('lang.spt8021124')], pic: 'wifi.png'},
          {label: _this.$t('lang.blueto'), desc: [_this.$t('lang.sptblt40'),_this.$t('lang.sptble')], pic: 'blt.png'},
          {label: _this.$t('lang.location'), desc: [_this.$t('lang.ingpsbdgln'),_this.$t('lang.sptlbsfunc'),_this.$t('lang.sptagps')], pic: 'lbs.png'},
          {label: _this.$t('lang.speaker'), desc: [_this.$t('lang.inspk05w'),_this.$t('lang.sdps82db3')], pic: 'speaker.png'},
          {label: _this.$t('lang.port'), desc: ['Micro USBx1、USB2.0 HSx2、RS232x1、RJ45x1'], pic: 'port.png'},
          {label: _this.$t('lang.button'), desc: [_this.$t('lang.powerbtn1')], pic: 'keyt.png'},
          {label: _this.$t('lang.bettery'), desc: ['锂电池3.7V/2000mAh'], pic: 'battery.png'},
          {label: _this.$t('lang.adapter'), desc: [_this.$t('lang.inputac100240'),'输出：DC 24V/2.5A'], pic: 'char.png'},
          {label: _this.$t('lang.size'), desc: ['255mm x 250mmx178mm'], pic: 'size.png'},
          {label: _this.$t('lang.suitenv'), desc: [_this.$t('lang.wktemp050')], pic: 'env.png'}
        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt8410 {
  background: white;
  margin-top: -.93rem;
}
#z1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8410/bg1.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 4.16rem;
  color: white;
}
#z1 div {
  margin-top: 2.13rem;
  font-size: .6rem;
  font-weight: bold;
}
#z1 label {
  display: block;
  font-weight: 400;
  margin-top: .07rem;
  font-size: .6rem;
}

#z2 {
  height: 1.78rem;
  background: #95A1A4 ;
  text-align: center;
}
#z2 label {
  display: inline-block;
  width: 9.16rem;
  font-size: .24rem;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: .45rem;
  line-height: .48rem;
}

#z3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8410/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 12.34rem;
  color: white;
}
#z3 div {
  margin: 0 0 .05rem 0;
  font-size: .3rem;
  font-weight: bold;
  color: #333333;
}
#z3 div:nth-child(1) {
  margin-top: 3.76rem;
}
#z3 div:nth-child(3) {
  margin-top: 1.15rem;
}
#z3 label {
  margin-left: .05rem;
  display: block;
  font-size: .16rem;
  font-weight: 400;
  color: #333333;
}

#z4 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8410/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
  text-align: center;
  overflow: hidden;
}
#z4 div {
  margin-top: 1.52rem;
  color: white;
  font-size: .56rem;
  margin-bottom: .34rem;
}
#z4 label {
  color: #F4F4F4;
  font-size: .24rem;
}
</style>
